import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePlaceNameCoverage } from './PlaceNameAutocomplete';
import { floatingPopperSx } from './LeadRecordSearch';
import { typography } from '../../styles/theme';
import {
  LEADS_BG_ELEVATED,
  LEADS_TEXT_MUTED,
  LEADS_TEXT_PRIMARY,
  leadsTextFieldSx,
} from './leadsUi.styles';

const ALL = '';
const PROVINCE_LIST_MAX_HEIGHT = 260;

const paperSx = {
  bgcolor: LEADS_BG_ELEVATED,
  color: LEADS_TEXT_PRIMARY,
  backgroundImage: 'none',
  border: '1px solid rgba(255,255,255,0.12)',
  borderRadius: '8px',
  boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
  '& .MuiAutocomplete-option': {
    fontSize: '14px',
    fontFamily: typography.fontFamily.primary,
    minHeight: 36,
  },
  '& .MuiAutocomplete-option.Mui-focused': { bgcolor: 'rgba(255,255,255,0.08)' },
  '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
    bgcolor: 'rgba(72,146,145,0.22)',
  },
  '& .MuiAutocomplete-noOptions': { fontSize: '13px', color: LEADS_TEXT_MUTED },
};

/**
 * Provincia de la búsqueda de lugares (opcional: solo acota, no se guarda).
 * Autocomplete con filtro al tipear; lista corta con scroll (~260 px).
 * Opciones = «Todas» + `coverage` de `/searchplacenames` (default: las del
 * catálogo al 19 oct 2026). «Todas» o borrar el texto → `''` (sin `province=`).
 * Sin helper con la lista de provincias (Ignacio: quedaba largo).
 * Recuperado de 59042a9.
 *
 * @param {{ value: string, onChange: (province: string) => void, disabled?: boolean,
 *   label?: string, ariaLabel?: string }} props
 */
export default function PlaceProvinceSelect({
  value = ALL, onChange, disabled = false, label, ariaLabel = 'Provincia',
}) {
  const coverage = usePlaceNameCoverage();
  const options = [ALL, ...coverage];
  const current = options.includes(value) ? value : ALL;
  return (
    <Autocomplete
      size="small"
      options={options}
      value={current}
      disabled={disabled}
      disableClearable={current === ALL}
      onChange={(_, next) => onChange(next || ALL)}
      getOptionLabel={(opt) => (opt === ALL ? 'Todas' : opt)}
      isOptionEqualToValue={(opt, val) => opt === val}
      noOptionsText="Sin coincidencias"
      clearText="Todas"
      openText="Abrir"
      closeText="Cerrar"
      autoHighlight
      slotProps={{
        listbox: { style: { maxHeight: PROVINCE_LIST_MAX_HEIGHT } },
        paper: { sx: paperSx },
        popper: { sx: floatingPopperSx },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputLabelProps={label ? { ...params.InputLabelProps, shrink: true } : params.InputLabelProps}
          inputProps={{ ...params.inputProps, 'aria-label': ariaLabel }}
          sx={{
            ...leadsTextFieldSx,
            '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root': { color: LEADS_TEXT_MUTED },
          }}
        />
      )}
    />
  );
}
